import React, { FC } from 'react'
import { Colors } from '../../styles/colors';
import { Operation, OperationStatus } from '../../interfaces/Operation';
import { Icon } from '../general/Icon';
import { AnimatedContainer, AnimatedContainerBounce } from '../general/AnimatedContainer';

interface Props {
	value: Operation[] | Operation | string;
	size?: number;
	textOnly?: boolean;
	fallback?: () => React.ReactNode;
}
export const OperationStateIcon: FC<Props> = ({ value, size = 32, textOnly = false, fallback }) => {
	let state = null;
	if (Array.isArray(value)) {
		const sortedOperations = value?.slice().sort((a: any, b: any) => {
			try {
				return b?.updatedAt?.localeCompare(a?.updatedAt);
			} catch (err) {
				//
			}
			return 0;
		});
		state = sortedOperations?.length > 0
			? sortedOperations?.reduce((state, item) => {
				if ([item.status as OperationStatus, state].includes(OperationStatus.ERROR)) {
					return OperationStatus.ERROR;
				}
				if ([item.status as OperationStatus, state].includes(OperationStatus.DONE)) {
					return OperationStatus.DONE;
				}
				if ([item.status as OperationStatus, state].includes(OperationStatus.OPEN)) {
					return OperationStatus.OPEN;
				}
				if ([item.status as OperationStatus, state].includes(OperationStatus.CREATED)) {
					return OperationStatus.CREATED;
				}
				if ([item.status as OperationStatus, state].includes(OperationStatus.CLOSED)) {
					return OperationStatus.CLOSED;
				}
				if ([item.status as OperationStatus, state].includes(OperationStatus.DELETED)) {
					return OperationStatus.DELETED;
				}
				return state;
			}, OperationStatus.CLOSED)
			: 'nostate';
	} else {
		state = typeof value === 'string' ? value : value?.status;
	}

	switch (state || 'undefined') {
		case OperationStatus.CLOSED:
			if (textOnly) {
				return <span>Abgeschlossen</span>;
			}
			return <Icon size={size} icon={'state-ok'} color={Colors.secondary} />;

		case OperationStatus.ERROR:
			if (textOnly) {
				return <span>Aktion erforderlich</span>;
			}
			return <Icon size={size} icon={'state-error'} color={Colors.error} />;

		case OperationStatus.DONE:
			if (textOnly) {
				return <span>Beratung nicht übertragen</span>;
			}
			return <Icon size={size} icon={'state-warn'} color={Colors.tertiary} />;

		case OperationStatus.DELETED:
			if (textOnly) {
				return <span>Gelöscht</span>;
			}
			return <Icon size={size} icon={'trash-time'} color={Colors.gray} />;

		case OperationStatus.OPEN:
			if (textOnly) {
				return <span>Offen</span>;
			}
			return <Icon size={size} icon={'state-unknown'} color={Colors.tertiary} />;
		case OperationStatus.CREATED:
		default:
			if (textOnly) {
				return <span>Erstellt</span>;
			}
			return <Icon size={size} icon={'state-unknown'} color={Colors.gray} />;
	}
}

export const AnimatedOperationStateIcon: FC<Props & { visible: boolean }> = ({ visible, ...props }) => {
	return (
		<AnimatedContainerBounce active={visible} delay={50}>
			<OperationStateIcon { ...props } />
		</AnimatedContainerBounce>
	);
}
